<template>
  <div id="campaign-detail-view" class="campaign-detail-view">
    <div class="col-md-12" style="width: 100%; height: 100%">
      <div
        slot="header"
        class="flex flex-wrap items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap items-center data-list-btn-container mb-4">
          <div style="margin-top: 20px; min-width: 100px">
            <a-input
              v-model="name"
              placeholder="MD 이름"
              @pressEnter="onSearchCampaign()"
              size="large"
            />
          </div>
          <div
            style="
              padding-top: 29px;
              padding-left: 5px;
              padding-right: 5px;
              min-width: 50px;
            "
          >
            - 또는 -
          </div>
          <div style="margin-top: 20px; min-width: 180px">
            <a-input
              v-model="enddate"
              placeholder="정산일 ( 예, 202011 )"
              @pressEnter="onSearchCampaign()"
              size="large"
            />
          </div>
          <div
            style="
              padding-top: 29px;
              padding-left: 5px;
              padding-right: 5px;
              min-width: 50px;
            "
          >
            - 또는 -
          </div>
          <div style="margin-top: 20px; min-width: 100px">
            <a-input
              v-model="seller"
              placeholder="판매자"
              @pressEnter="onSearchCampaign()"
              size="large"
            />
          </div>
          <div
            style="
              padding-top: 29px;
              padding-left: 5px;
              padding-right: 5px;
              min-width: 50px;
            "
          >
            - 또는 -
          </div>
          <div style="margin-top: 20px; min-width: 100px">
            <a-input
              v-model="sr"
              placeholder="SR번호"
              @pressEnter="onSearchCampaign()"
              size="large"
            />
          </div>
          <div
            style="
              padding-top: 29px;
              padding-left: 5px;
              padding-right: 5px;
              min-width: 50px;
            "
          >
            - 또는 -
          </div>
          <div style="margin-top: 20px; min-width: 100px" class="s-o-btn1">
            <a-input v-model="product" placeholder="상품명" size="large">
            </a-input>
          </div>
          <div style="margin-top: 20px; margin-left: 10px" class="s-o-btn1">
            <a-button
              :loading="loadable"
              style="height: 40px"
              slot="enterButton"
              type="primary"
              @click="onSearchCampaign()"
            >
              검색
            </a-button>
          </div>
        </div>
        <div style="overflow-x: scroll">
          <a-table
            class="col-width-max-content"
            :columns="ccolumns"
            :data-source="ctableData"
            :scroll="{ x: true }"
            rowKey="doc_id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

Date.prototype.addDays = function (days) {
  const date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}

import {
  getLicense,
  replaceAll,
  getCurrentTime,
  isMobile,
  showError,
  showSuccess
} from "../../components/fnc"
import firebase from "firebase"
import NavFooter from "../../../layouts/components/nav/NavFooter.vue"
export default {
  components: {
    NavFooter
  },
  data () {
    return {
      loadable: false,

      seller: "",
      sr: "",
      product: "",
      enddate: "",
      name: "",
      users: [],
      allCampaigns: [],
      ctableData: [],
      ccolumns: [
        {
          title: "주문번호",
          dataIndex: "order_id",
          key: "order_id",
          align: "left",
          width: "160px"
        },
        {
          title: "담당자명",
          dataIndex: "name",
          key: "name",
          align: "left",
          width: "100px"
        },
        {
          title: "계약일",
          key: "contract_date",
          align: "left",
          dataIndex: "contract_date",
          width: "110px"
        },
        {
          title: "판매자명",
          key: "seller_name",
          dataIndex: "seller_name",
          align: "left",
          width: "100px"
        },
        {
          title: "제품명",
          key: "title",
          dataIndex: "title",
          align: "left"
        },
        {
          title: "진행인원수",
          key: "org_applier_cnt",
          dataIndex: "org_applier_cnt",
          align: "left",
          width: "90px"
        },
        {
          title: "실제모집수",
          key: "max_applier_cnt",
          dataIndex: "max_applier_cnt",
          align: "left",
          width: "90px"
        },
        {
          title: "이벤트인원",
          key: "event_applier_cnt",
          align: "left",
          dataIndex: "event_applier_cnt",
          width: "90px"
        },
        {
          title: "건당배분액",
          key: "per_amount",
          align: "left",
          dataIndex: "per_amount",
          width: "90px"
        },
        {
          title: "총 수익",
          key: "total",
          align: "left",
          dataIndex: "total",
          width: "110px"
        },
        {
          title: "상태",
          key: "campaign_state_cd",
          align: "left",
          dataIndex: "campaign_state_cd",
          width: "100px"
        },
        {
          title: "종료(예정)일",
          key: "end_date",
          align: "left",
          dataIndex: "end_date",
          width: "110px"
        },
        {
          title: "적립(예정)일",
          key: "saving_date",
          align: "left",
          dataIndex: "saving_date",
          width: "110px"
        }
      ]
    }
  },
  mounted () {
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true)
    this.onLoadUser()
  },
  computed: {
    getName () {
      return this.$store.state.AppActiveUser.displayName
    },
    getUid () {
      return this.$store.state.AppActiveUser.uid
    },
    getEmail () {
      return this.$store.state.AppActiveUser.email
    },
    getUserKey () {
      return this.$store.state.AppActiveUser.key
    }
  },
  methods: {
    _mobile () {
      return isMobile()
    },
    onLoadUser () {
      const self = this
      const db = firebase.firestore()
      db.collection("retail_user")
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            self.users.push(doc.data())
          })

          self.onLoadCampaign()
        })
    },
    onLoadCampaign () {
      const self = this
      const db = firebase.firestore()
      db.collection("retail_campaign")
        .orderBy("contract_date", "desc")
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let _name = ""

            self.users.find(item => {
              if (parseInt(item.member_id) === parseInt(doc.data().member_id)) {
                _name = item.name
              }
            })

            const _t = { ...doc.data(), doc_id: doc.id }

            _t["saving_date"] = doc.data().saving_date
              ? doc.data().saving_date.substr(0, 6)
              : "-"
            _t["name"] = _name
            self.allCampaigns.push(_t)
          })

          self.loading = false
        })
    },
    onSearchCampaign () {
      this.ctableData = []
      const self = this

      if (
        this.seller === "" &&
        this.product === "" &&
        this.sr === "" &&
        this.name === "" &&
        this.enddate === ""
      ) {
        showError({
          notify: this.$vs.notify,
          msg: "적어도 하나는 필수 입니다."
        })
      } else {
        this.loading = true
        this.allCampaigns.forEach(item => {
          if (
            ((self.seller && item.seller_name.indexOf(self.seller) >= 0) ||
              self.seller === "") &&
            ((self.product && item.title.indexOf(self.product) >= 0) ||
              self.product === "") &&
            ((self.sr && item.order_id.indexOf(self.sr) >= 0) ||
              self.sr === "") &&
            ((self.enddate && item.saving_date.indexOf(self.enddate) >= 0) ||
              self.enddate === "") &&
            ((self.name && item.name.indexOf(self.name) >= 0) ||
              self.name === "")
          ) {
            const _t = {
              // set rowKey
              doc_id: item.doc_id,
              order_id: item.order_id,
              name: item.name,
              contract_date: item.contract_date,
              seller_name: item.seller_name,
              title: item.title,
              org_applier_cnt: item.org_applier_cnt,
              max_applier_cnt: item.max_applier_cnt,
              event_applier_cnt: item.event_applier_cnt,
              end_month: item.end_month,
              per_amount: `${parseInt(item.per_amount).toLocaleString()}원`,
              total: `${(
                parseInt(item.per_amount) * parseInt(item.org_applier_cnt)
              ).toLocaleString()}원`,
              campaign_state_cd:
                item.campaign_state_cd === "0803" ? "캠페인완료" : "진행중",
              end_date: item.end_date,
              saving_date: item.saving_date
            }

            self.ctableData.push(_t)
            self.loading = false
          }
        })
      }
    }
  }
}
</script>

<style>
</style>
